export default __webpack_public_path__ + "assets/media/video-empty.7650248c.png";